// import $ from 'jquery';
import { getI18NMessage, getCookieData } from '../service';
import { BtnApply, BtnClose, ChkOptional2Id, ChkOptional3Id, ChkOptionalId, ChkRquired, GCookieSetDimmedId, GCookieSetLayerId, getSeetingLayerTemplate, InfoOptional, InfoOptional2, InfoRequired, Infos, InfosContent, IsActive, RadioTabRequired, RadioTabs, TopDesc } from '../template/settingLayer';
import {getUriParam} from '../util/util2';
import { LoaderTargetPlugin } from 'webpack';
import { getCountry, getLang } from '../util/util';
import AbsGlobalCookie from './AbsGlobalCookie';


const TAB_REQUIRED = 'TAB_REQUIRED';
const TAB_OPTIONAL = 'TAB_OPTIONAL';
type TABS = typeof TAB_REQUIRED | typeof TAB_OPTIONAL;

export default class SettingModal extends AbsGlobalCookie {
    curOptCookieListVer!: string;
    zIndex: number;
    apiDomain: string;
    contiCookieDataApi: string;
    contiApiUrl: string;

    // getAllCookieNamesFromConti!: () => Record<keyof CookieDatas, string[]>;
    cookieNamesToDelete!: ReturnType<InstanceType<typeof AbsGlobalCookie>['_getNotAppiedCookieNames']>;

    constructor({zIndex = 1, apiDomain = '', contiCookieDataApi = ''}: {zIndex?: number, apiDomain?: string, contiCookieDataApi?: string} = {}){
        super();

        this.zIndex = zIndex;
        this.apiDomain = apiDomain;
        this.contiCookieDataApi = contiCookieDataApi;
        this.contiApiUrl = this.apiDomain + this.contiCookieDataApi
        this.init();
    }

    async init(): Promise<void>{
        try{
            let lang = getLang({onlyUsingLanguageArr: ['ar', 'en', 'id', 'ja', 'ko', 'th', 'zh', 'ru'], defaultLang: 'en'});
            let country = getCountry();

            // I18N 받아오기 & 쿠키 리스트 받아오기 (쿠키 리스트 언어는 항상 en)
            let textData = (await getI18NMessage('en')).settingModal;
            let cookieDataWrap = await getCookieData(country, this.contiApiUrl);

            let cookieDataOptionals = this._getCookieDataOptionals(cookieDataWrap) as ContiContentAPIResponse<CONTI_ALIAS_GLOBAL_COOKIE_LIST_OPTIONALS>;
            let cookieDataRequired = this._getCookieDataRequired(cookieDataWrap) as ContiContentAPIResponse<CONTI_ALIAS_GLOBAL_COOKIE_LIST_REQUIRED>;

            // 선택 쿠키 버전
            this.curOptCookieListVer = String(cookieDataOptionals.version);

            // 쿠키 데이터
            let cookieDatas: CookieDatas = this._getCookeDatas(cookieDataOptionals, cookieDataRequired);

            // 쿠키 데이터가 필요한 메서드 (왜 this.cookeDatas 로 하여 사용하지 않는가? 그냥.)
            // this.getAllCookieNamesFromConti = super.getAllCookieNamesFromConti.bind(this, cookieDatas);
            this.cookieNamesToDelete = this.getCookieNamesToDeleteSuper(cookieDatas);

            // 저장하지 않은 타입의 First-party 쿠키 삭제 (여기서 해줘야 하나?)
            // window.onload 시점으로 잡을수 없는 이유는
            // ConfirmToast 의 init() 이 async 함수로,
            // init() 내부에서 ajax 통신을 통해 쿠키 데이터를 가져오는데,
            // 이때 비동기 화 되면서, window.onload 이벤트 걸기전에,
            // window load 가 완료 되버리는 경우가 생긴다.

            // 테스트 결과 간헐적으로 window.onload 이벤트 거는 곳까지 window load가 안되는 경우가 있는데,
            // 그건 init() 내부의 ajax 통신이 document 의 스크립트 로드보다 빨라서 window load 시점이 안되었기 때문으로 보인다.

            // ajax로 파일을 로드 할경우 ajax 호출의 경우 완료가 안되도, window.onload 가 발생하고, 이후에 파일을 이어서 받아온다.
            // https://docs.newrelic.com/docs/browser/new-relic-browser/page-load-timing-resources/page-load-timing-process/
            // The page finishes rendering in the user's browser and the window load event fires. (For pages that use asynchronous loading, some elements may continue to load after the window load event occurs.)
            !this.isKoreaLanguge() && this.deleteCookies(this.cookieNamesToDelete);


            // 레이어 템플릿
            this._setTemplate( textData, cookieDatas, this.zIndex );

            // 이벤트 바인딩하고
            this._bindEvent(textData);

            // 리셋
            this.reset();

            // temp
            window.showLayer = this.showLayer;
        }catch(err){
            // console.error(err);
        }
    }

    _setTemplate(textData:SettingModalTextData,  cookieData: CookieDatas, zIndex?: number): void{
        // 레이어 템플릿
        let template = getSeetingLayerTemplate(textData, cookieData, zIndex);
        // $('body').append(template);
        document.body.insertAdjacentHTML('beforeend',template);

        // $(`.${TopDesc} a`).attr('href', URL_COOKIE_POLICY);
    }

    // 레이어 보여주기
    showLayer = ():void => {
        this.displayLayer(true);
    };

    // 레이어 닫기
    hideLayer = (): void => {
        this.displayLayer(false);
    };

    _bindEvent(textData: SettingModalTextData): void{
        // 레이어 닫기 클릭
        // $(document).on('click', `#${GCookieSetLayerId} .${BtnClose}`, this.onClickBtnClose);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieSetLayerId} .${BtnClose}`);
            delegateTarget && this.onClickBtnClose();
        });
        // 저장하기 클릭
        // $(document).on('click', `#${GCookieSetLayerId} .${BtnApply}`, this.onClickBtnApply.bind(null, textData));
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieSetLayerId} .${BtnApply}`);
            delegateTarget && this.onClickBtnApply(textData);
        });
        // 필수쿠키 허용 클릭
        // $(document).on('click', `#${GCookieSetLayerId} .${ChkRquired}`, this.onClickChkRquired);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieSetLayerId} .${ChkRquired}`);
            delegateTarget && this.onClickChkRquired(e);
        });
        // 탭 클릭 (필수쿠키 / 선택 쿠키)
        // $(document).on('click', `#${GCookieSetLayerId} .${RadioTabs}`, this.onClickRadioTabs);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieSetLayerId} .${RadioTabs}`);
            delegateTarget && this.onClickRadioTabs(e);
        });
        // 딤드 클릭
        // $(document).on('click', `#${GCookieSetDimmedId}`, this.onClickDimmed);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieSetDimmedId}`);
            delegateTarget && this.onClickDimmed();
        });
        // 쿠키정책(a 태크) 클릭시
        // $(document).on('click', `#${GCookieSetLayerId} .${TopDesc} a`, this.onClickTopDescAnchorTag);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieSetLayerId} .${TopDesc} a`);
            delegateTarget && this.onClickTopDescAnchorTag(e);
        });
        // 성공메시지 확인 클릭 (메시지창 닫기) - [TODO]

    }

    // 쿠키정책(a 태크) 클릭시
    onClickTopDescAnchorTag = (e: MouseEvent):void => {
        e.preventDefault();

        window.open(this.URL_COOKIE_POLICY, '_blank');
    };

    // 딤드 클릭
    onClickDimmed = (): void => {

        // 기존에 동의한 내용이 있다면 (쿠키가 있다면) 그대로 두고 / 없다면 필수 동의
        if(!this.hasBeenAppliedCookie) this._applyCookieOnlyRequired(this.curOptCookieListVer, location.href);

        // 레이어 닫기
        this.hideLayer();
    };

    // 레이어 닫기 클릭
    onClickBtnClose = ():void =>  {

        // 기존에 동의한 내용이 있다면 (쿠키가 있다면) 그대로 두고 / 없다면 필수 동의
        if(!this.hasBeenAppliedCookie) this._applyCookieOnlyRequired(this.curOptCookieListVer, location.href);

        // 레이어 닫기
        this.hideLayer();
    };

    // 레이어 출력/닫기
    displayLayer(flag: boolean): void{
        if(flag){
            //   $(`#${GCookieSetLayerId}`).addClass(IsActive);
            //   $(`#${GCookieSetDimmedId}`).addClass(IsActive);
            document.getElementById(GCookieSetLayerId)?.classList.add(IsActive);
            document.getElementById(GCookieSetDimmedId)?.classList.add(IsActive);

        }else{
            // $(`#${GCookieSetLayerId}`).removeClass(IsActive);
            // $(`#${GCookieSetDimmedId}`).removeClass(IsActive);
            document.getElementById(GCookieSetLayerId)?.classList.remove(IsActive);
            document.getElementById(GCookieSetDimmedId)?.classList.remove(IsActive);
        }
    }

    // 저장하기 클릭
    onClickBtnApply = (textData: SettingModalTextData):void =>   {
        let applyCookieTypeArr: ApplyCookieTypeArr = [];

        applyCookieTypeArr.push('NECESSARY');
        this.isCheckedOptional && applyCookieTypeArr.push('FUNCTIONAL');
        this.isCheckedOptional2 && applyCookieTypeArr.push('PERFORMANCE');
        this.isCheckedOptional3 && applyCookieTypeArr.push('ADVERTISING');

        window.alert(textData.msgSuccess);

        this._applyCookie(applyCookieTypeArr, this.curOptCookieListVer, location.href);

        // this.hideLayer();
    };

    // 필수쿠키 허용 클릭
    onClickChkRquired = (evt: MouseEvent):void =>   {
        evt.preventDefault();
    };

    // 탭 클릭 (필수쿠키 / 선택 쿠키)
    onClickRadioTabs = (evt: MouseEvent):void => {
        // let targetSelector: typeof InfoRequired | typeof InfoOptional | typeof InfoOptional2 = $(evt.target).data('target');
        let targetSelector = (evt.target as HTMLElement).dataset.target;

        this._showCookieInfoByRadioTabls(targetSelector as typeof InfoRequired | typeof InfoOptional | typeof InfoOptional2 );
    };

    // 클릭된 탭에 따라 보여줄 쿠키정보 선택
    _showCookieInfoByRadioTabls(targetSelector: typeof InfoRequired | typeof InfoOptional | typeof InfoOptional2): void {
        const infoEls = Array.from(document.getElementsByClassName('g-cookie-info'));

        for(let infoEl of infoEls){
            infoEl.classList.remove(IsActive);
        }

        infoEls.find(e => e.classList.contains(targetSelector))?.classList.add(IsActive);
        // $(`.${Infos}`).removeClass(IsActive);
        // $(`.${Infos}.${targetSelector}`).addClass(IsActive);
    }

    // 리셋
    reset(): void{
        // 만약 파라미터에 showLayer 있으면 showLayer 실행
        getUriParam(location.href, 'showLayer') === 'true' && this.showLayer();

        // 필수 쿠키 탭클릭
        // $(`.${RadioTabRequired}`).trigger('click');
        for(let El of document.getElementsByClassName(RadioTabRequired)){
            El.dispatchEvent(new PointerEvent('click',{bubbles:true}));
        }

        // [TODO] 기존에 선택 되어 있던 쿠키에 따라 탭클릭
        this.selectRadioAsHasAppliedCookieType();
    }

    // 기존에 선택 되어 있던 쿠키에 따라 탭클릭
    selectRadioAsHasAppliedCookieType(): void{
        let targetArr = this.getHasBeenAppliedCookieTypes();
        if(!targetArr) return;

        // targetArr.includes('FUNCTIONAL') && $(`#${ChkOptionalId}`).trigger('click');
        // targetArr.includes('PERFORMANCE') && $(`#${ChkOptional2Id}`).trigger('click');
        // targetArr.includes('ADVERTISING') && $(`#${ChkOptional3Id}`).trigger('click');
        targetArr.includes('FUNCTIONAL') && document.getElementById(ChkOptionalId)?.dispatchEvent(new PointerEvent('click',{bubbles:true}));
        targetArr.includes('PERFORMANCE') && document.getElementById(ChkOptional2Id)?.dispatchEvent(new PointerEvent('click',{bubbles:true}));
        targetArr.includes('ADVERTISING') && document.getElementById(ChkOptional3Id)?.dispatchEvent(new PointerEvent('click',{bubbles:true}));
    }

    // 선택쿠키 허용 체크박스 체크 여부
    get isCheckedOptional(): boolean{
        // return $(`#${ChkOptionalId}`).is(':checked');
        return (document.getElementById(ChkOptionalId) as HTMLInputElement).checked;
    }

    // 선택쿠키2 허용 체크박스 체크 여부
    get isCheckedOptional2(): boolean{
        // return $(`#${ChkOptional2Id}`).is(':checked');
        return (document.getElementById(ChkOptional2Id) as HTMLInputElement).checked;

    }

    // 선택쿠키3 허용 체크박스 체크 여부
    get isCheckedOptional3(): boolean{
        // return $(`#${ChkOptional3Id}`).is(':checked');
        return (document.getElementById(ChkOptional3Id) as HTMLInputElement).checked;

    }

    // 필수쿠키 허용 체크박스 체크 여부 : 무조건 true
    get isCheckedRequired(): boolean{
        return true;
    }


}
